<template>
  <div class="know-pdv-page">
    <div class="section">
      <img src="../assets/imgs/know/top.png" alt="" />
    </div>
    <div class="section video-section">
      <img src="../assets/imgs/know/video.png" alt="" />
      <div class="video-play-box" @click="playVideo"></div>
      <div
        class="video-dialog"
        v-show="showVideoDialog"
        @touchmove.stop.prevent="() => {}"
      >
        <div class="mask"></div>
        <div class="video-box">
          <div class="close" @click="closeVideo"></div>
          <video
            class="know-video"
            v-if="!videoHide"
            ref="video"
            src="https://pbs-public.oss-cn-shenzhen.aliyuncs.com/static-visa/video/propagate.mp4"
            controls
            @ended="endedVideo"
          ></video>
        </div>
      </div>
    </div>

    <div class="section">
      <img src="../assets/imgs/know/feature-2.jpg" alt="" />
    </div>
    <div class="section footer">
      <img src="../assets/imgs/know/footer.png" alt="" />
      <div class="footer-btn" @click="gotoPdvHome">现在去逛逛</div>
    </div>
  </div>
</template>
<script>
import utils from '../services/tools.js';
import dev from '../services/dev.js';

export default {
  name: 'knowPdv',
  data() {
    return {
      showVideoDialog: false,
      videoHide: false,
    };
  },
  created() {
    this.is_in_app = this.$route.query.is_in_app || 0;
    utils.bridgeInit();
  },
  methods: {
    playVideo() {
      this.showVideoDialog = true;
      const video = this.$refs.video;
      this.openFullScreen(video);
      video.play();
    },
    endedVideo() {
      this.exitFullScreen();
      this.closeVideo();
    },
    // 全屏播放方法
    openFullScreen(element) {
      if (element.requestFullScreen) {
        element.requestFullScreen();
      } else if (element.mozRequestFullScreen) {
        // 其次，检测Mozilla的方法
        element.mozRequestFullScreen();
      } else if (element.webkitRequestFullScreen) {
        // if 检测 webkit的API
        element.webkitRequestFullScreen();
      }
    },
    exitFullScreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      }
    },
    closeVideo() {
      const video = this.$refs.video;
      video.pause();
      video.currentTime = 0;
      this.showVideoDialog = false;
      this.videoHide = true;
      setTimeout(() => {
        this.videoHide = false;
      }, 100);
    },
    gotoPdvHome() {
      if (utils.isWxa()) {
        wx.miniProgram.switchTab({ url: '/pages/index/index' });
      } else if (this.is_in_app) {
        utils.getBridge((bridge) => {
          bridge.callHandler('popBack', {}, () => {});
        });
      } else {
        url = `https://${dev}m.11visa.com`;
        window.location.href = url;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.know-pdv-page {
  background: url('../assets/imgs/know/bg.png') #ffc0b6 no-repeat top left;
  background-size: 100% auto;
  min-height: 100%;
}
.section {
  font-size: 0;
  img {
    width: 100%;
  }
}
.video-section {
  position: relative;
  .video-play-box {
    position: absolute;
    left: 50%;
    top: 1rem;
    transform: translateX(-50%);
    width: 3.24rem;
    height: 1.85rem;
    z-index: 1;
  }
  .video-dialog {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 50;
    .mask {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.7);
    }
    .video-box {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      z-index: 10;
      width: 100%;
      .close {
        position: absolute;
        background: url('../assets/imgs/close.png') no-repeat 0 0;
        background-size: 0.25rem 0.25rem;
        width: 0.25rem;
        height: 0.25rem;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: -0.75rem;
        z-index: 11;
      }
      .know-video {
        width: 100%;
      }
    }
  }
}
.footer {
  position: relative;

  .footer-btn {
    position: absolute;
    top: 0.15rem;
    left: 50%;
    transform: translateX(-50%);
    width: 2.8rem;
    height: 0.45rem;
    background: linear-gradient(
      -10deg,
      rgba(244, 71, 73, 1) 0%,
      rgba(255, 81, 58, 1) 100%
    );
    box-shadow: 0px 8px 24px 0px rgba(229, 31, 34, 0.5),
      0px 8px 24px 0px rgba(252, 51, 54, 0.6);
    border-radius: 0.225rem;
    font-size: 0.17rem;
    font-weight: 600;
    text-shadow: 0px 0.02rem 0.015rem rgba(255, 75, 77, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
  }
}
</style>
